import React from "react";
import ChangePassword from "../../components/changePassword";

function ChangePasswordPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <ChangePassword />
    </div>
  );
}

export default ChangePasswordPage;
